import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../actions/LoginActions";
import { actionCreators as nActions } from "../actions/NotificationActions";
import { Redirect } from "react-router";
import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden",
            userName: "",
            password: ""
        };

        this.handleChange = this.handleChange.bind(this);
        this.performLogin = this.performLogin.bind(this);
    }

    componentWillMount() {
        this.props.checkLogin();
    }

    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        this.timeOutFunction = setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isFailed) {
            this.props.showNotification({ message: "Login Failed", place: "tc", type: "danger", unique: true });
        }
        if (nextProps.isAuth) {
            this.props.showNotification({ message: "Login Successfull!", place: "tc" });
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeOutFunction);
        this.timeOutFunction = null;
    }


    handleChange(e) {
        const name = e.target.name;
        this.setState({ [name]: e.target.value });
    }

    performLogin(e) {
        e.preventDefault();
        let disabled = this.state.userName.length < 3 || this.state.password.length < 6 || this.props.isAuthorizing;
        if (disabled) {
            return;
        }
        //console.log(this.state);
        
        this.props.requestLogin(this.state.userName, this.state.password);
    }

    render() {
        
        const { classes, isAuth, isAuthorizing } = this.props;

        if (isAuth && this.props.auth.roles) {
            return <Redirect to="/" />;
        }
        return (
            <div className={classes.container}>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={6} md={4}>
                        <form onSubmit={this.performLogin} >
                            <Card login className={classes[this.state.cardAnimaton]} style={{padding:"23px"}}>
                                <CardHeader className={`${classes.cardHeader} ${classes.textCenter}`} >
                                    <h4 className={classes.cardTitle}>Log in</h4>
                                    <div className={classes.headerLine}></div>
                                    <div></div>
                                    {/*
                                    <div className={classes.socialLine}>
                                        {[
                                            "fab fa-facebook-square",
                                            "fab fa-twitter",
                                            "fab fa-google-plus"
                                        ].map((prop, key) => {
                                            return (
                                                <Button color="transparent" justIcon key={key} className={classes.customButtonClass}>
                                                    <i className={prop} />
                                                </Button>
                                            );
                                        })}
                                    </div>
                                    */}
                                </CardHeader>
                                <CardBody>
                                    <CustomInput labelText="User Name..." id="email" formControlProps={{ fullWidth: true }}
                                        inputProps={{
                                            name: "userName",
                                            onChange: this.handleChange,
                                            value: this.state.userName,
                                            endAdornment: <InputAdornment position="end"><Email className={classes.inputAdornmentIcon} /></InputAdornment>
                                        }} />
                                    <CustomInput labelText="Password" id="password" formControlProps={{ fullWidth: true }}
                                        inputProps={{
                                            name: "password",
                                            onChange: this.handleChange,
                                            value: this.state.password,
                                            type: "password",
                                            endAdornment: <InputAdornment position="end"><Icon className={classes.inputAdornmentIcon}>lock_outline</Icon></InputAdornment>
                                        }}
                                    />
                                    <Button type="submit" color="success" disabled={this.state.userName.length < 3 || this.state.password.length < 6 || isAuthorizing} size="sm" block>{isAuthorizing ? "Logging in..." : "Login"}</Button>
                                </CardBody>
                                <CardFooter className={classes.justifyContentCenter}>
                                    <p className={classes.footerText}><a href="https://xeon.technology/">Xeon Technology</a> ERP</p>
                                </CardFooter>
                            </Card>
                        </form>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

LoginPage.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(connect(
    state => state.login,
    dispatch => bindActionCreators({ ...actionCreators, showNotification: nActions.showNotification}, dispatch)
)(LoginPage));



// WEBPACK FOOTER //
// ./src/erp/LoginPage.js